import { Effect, Context, Layer } from 'effect';
import Cookies from 'js-cookie';

interface LocaleCookie {
  locale: string;
  rtl: boolean;
}

const makeCookieService = Effect.sync(() => {
  const parseLocaleCookie = (cookieValue: string | undefined): LocaleCookie | null => {
    if (!cookieValue) return null;

    try {
      const parsed = JSON.parse(cookieValue);
      return {
        locale: parsed.locale || 'en',
        rtl: parsed.rtl || false,
      };
    } catch (error) {
      console.error('Failed to parse locale cookie:', error);
      return null;
    }
  };

  return {
    getLocale: () =>
      Effect.sync(() => {
        const cookieValue = Cookies.get('locale');
        const parsed = parseLocaleCookie(cookieValue);
        return parsed?.locale || 'en';
      }),
    getRtl: () =>
      Effect.sync(() => {
        const cookieValue = Cookies.get('locale');
        const parsed = parseLocaleCookie(cookieValue);
        return parsed?.rtl || false;
      }),
  };
});

export class CookieService extends Context.Tag('CookieService')<
  CookieService,
  Effect.Effect.Success<typeof makeCookieService>
>() {
  static readonly Live = Layer.effect(this, makeCookieService);
}
